import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { login as apiLogin, me as apiMe } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        const token = localStorage.getItem("ab_admin_token");
        if (!token) { setUser(null); setLoading(false); return; }
        try {
            const r = await apiMe();
            setUser(r.data);
        } catch {
            setUser(null);
            localStorage.removeItem("ab_admin_token");
            localStorage.removeItem("ab_admin_username");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    const login = async (username, password) => {
        const r = await apiLogin(username, password);
        localStorage.setItem("ab_admin_token", r.data.access_token);
        localStorage.setItem("ab_admin_username", r.data.username);
        setUser({ username: r.data.username });
        return r.data;
    };

    const logout = () => {
        localStorage.removeItem("ab_admin_token");
        localStorage.removeItem("ab_admin_username");
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
    return ctx;
}
